module.exports = __webpack_public_path__ + "img/t1-14.d9e8a816.png";